import * as React from 'react';

import { withIntl, IntlProps } from 'ha/i18n';
import Link from 'ha/ui/next/Link';
import Img from 'ha/ui/next/Img';
import Track from 'ha/components/track/SmartTrack';
import haLogo from 'img-src/logos/housing-anywhere-logo.svg';

export const NavBarLogo: React.SFC<IntlProps> = ({ intl: { urlResolver } }) => (
  <Track name="Clicked Logo in header" type="icon">
    <Link to={urlResolver.getHomeUrl()} data-test-locator="HA Logo">
      <Img src={haLogo} alt="Housing Anywhere" />
    </Link>
  </Track>
);

export default withIntl(NavBarLogo);
